import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Moment from "moment";
import { Flex } from "@100mslive/roomkit-react";
import { Edit, ViewIcon } from "../../../icons";
import formatDateTime from "../../Common/formatDateTime";
import { ToastManager } from "../../Toast/ToastManager";
import CompanyPostFilter from "./CompanyPostFilter";
import CompanyPostView from "./CompanyPostView";
import { SESSION_AUTH } from "../../../common/auth";
import { COMPANY_SERVICES } from "../../../services";
import { POST_STATUS } from "../../../common/constants";

const CompanyPostContent = props => {
  const { orgId, setPostsAction, isAccessMember, setSelectedPost } = props;
  const { isUserSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const [listData, setListData] = useState([]);
  const [dataFetched, setDataFetched] = useState(true);
  const [loading, setLoading] = useState(false);
  const [enblePostView, setEnblePostView] = useState("");

  const [totalPage, setTotalPage] = useState(0);
  const [filter, setFilter] = useState({
    status: "",
    page: 1,
    category: "",
    tags: "",
  });

  useEffect(() => {
    if (dataFetched) return;
    setDataFetched(true);
    setLoading(true);
    let parma = {
      limit: 20,
      page: filter?.page,
      id: orgId,
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
    };
    if (filter?.status) {
      parma["status"] = filter?.status;
    }
    if (filter?.category) {
      parma["category"] = filter?.category;
    }
    if (filter?.tags) {
      parma["tags"] = filter?.tags;
    }
    COMPANY_SERVICES.posts(parma)
      .then(data => {
        if (data.code === 200) {
          setListData(data.data?.list);
          if (data.data?.pageInfo?.page === 1) {
            setTotalPage(data.data?.pageInfo?.totalPage || 0);
          }
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dataFetched, filter, orgId, isUserSession, LOGOUT_USER_SESSION]);

  useEffect(() => {
    setDataFetched(false);
  }, [filter]);

  const handleChangePage = (event, newPage) => {
    if (filter?.page === newPage) return;
    setFilter(old => ({
      ...old,
      page: newPage,
    }));
  };

  const onChangeFilter = (type, value) => {
    setFilter(old => ({
      ...old,
      page: 1,
      [type]: value,
    }));
  };

  return (
    <React.Fragment>
      {isAccessMember ? (
        <CompanyPostFilter
          onChangeFilter={onChangeFilter}
          filter={filter}
          setPostsAction={setPostsAction}
          orgId={orgId}
        />
      ) : null}

      <div className="event-page-company-posts-content">
        <TableContainer className="event-page-company-posts-content-table">
          <Table sx={{ minWidth: 550 }} aria-label="post table">
            <TableHead>
              <TableRow>
                <TableCell>Time</TableCell>
                <TableCell>Headline</TableCell>
                <TableCell align="right">Provider</TableCell>
                {isAccessMember && (
                  <>
                    <TableCell>Visibility</TableCell>
                    <TableCell>&nbsp;</TableCell>
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                Array.from({ length: listData?.length || 10 }).map(
                  (_, index) => (
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      key={index}
                    >
                      <TableCell>
                        <div className="event-page-company-posts-content-table-loading" />
                      </TableCell>
                      <TableCell>
                        <div className="event-page-company-posts-content-table-loading" />
                      </TableCell>

                      <TableCell>
                        <div className="event-page-company-posts-content-table-loading" />
                      </TableCell>
                      {isAccessMember && (
                        <>
                          <TableCell>
                            <div className="event-page-company-posts-content-table-loading" />
                          </TableCell>
                          <TableCell>
                            <div className="event-page-company-posts-content-table-loading" />
                          </TableCell>
                        </>
                      )}
                    </TableRow>
                  )
                )
              ) : listData?.length > 0 ? (
                listData.map((list, index) => (
                  <TableRow
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                    key={index}
                  >
                    <TableCell>
                      {list?.publishedAt
                        ? list?.status === POST_STATUS?.[2].value ||
                          list?.status === POST_STATUS?.[3].value
                          ? Moment(list?.publishedAt).format(
                              "MMM DD YYYY hh:mm A"
                            )
                          : formatDateTime(list?.publishedAt)
                        : "-"}
                    </TableCell>
                    <TableCell>
                      {list?.status === POST_STATUS?.[4]?.value ||
                      list?.status === POST_STATUS?.[5]?.value ? (
                        <Link
                          to={`/post/${list?.postSlug}`}
                          className="event-page-company-posts-content-table-title"
                        >
                          {list?.postTitle}
                        </Link>
                      ) : (
                        <div className="event-page-company-posts-content-table-title">
                          {list?.postTitle}
                        </div>
                      )}
                    </TableCell>

                    <TableCell align="right">{list?.author?.name}</TableCell>
                    {isAccessMember && (
                      <>
                        <TableCell>
                          {POST_STATUS?.[list?.status]?.name}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            variant="outlined"
                            className="events6ix-btn events6ix-btn-light events6ix-btn-sm"
                            type="button"
                            onClick={() => {
                              setSelectedPost(list);
                              setPostsAction("edit");
                            }}
                            title="Edit Post"
                          >
                            <Edit />
                          </Button>
                          <Button
                            variant="outlined"
                            className="events6ix-btn events6ix-btn-light events6ix-btn-sm ml-5"
                            type="button"
                            onClick={() => {
                              setEnblePostView(list?._id);
                            }}
                            title="View Post"
                          >
                            <ViewIcon />
                          </Button>
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell colSpan={isAccessMember ? 5 : 3}>
                    <div className="event-page-company-posts-content-empty">
                      Looks like there's nothing to report right now.
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPage > 1 && (
          <Flex justify="center" className="text-center mt-20">
            <Pagination
              variant="text"
              onChange={handleChangePage}
              page={filter?.page}
              count={totalPage}
            />
          </Flex>
        )}

        {enblePostView ? (
          <CompanyPostView
            postId={enblePostView}
            orgId={orgId}
            onClose={() => {
              setEnblePostView("");
            }}
          />
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default CompanyPostContent;
